export default {
  items: [
    {
      title: 'voip.nav.title',
      id: 'Voip',
      to: null,
      icon: 'icon',
      sortOrder: 10,
      expanded: true,
      children: [
        {
          title: 'voip.nav.title',
          to: { name : 'VoipIndexPage'},
          icon: 'user',
          sortOrder: 10,
        }
      ]
    }
  ]
}
